import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { debounce } from "lodash";
import { enqueueSnackbar } from "notistack";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { searchUser } from "../../DAL/fetch";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AssingnDeactive } from "../../DAL/update";

const AddDeactiveUser = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchValue, setSearchValue] = useState();

  const hello = data[0]?.id;

  const labelStyles = {
    color: "", // Default label color
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
  };
  const inputStyles = {
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0", // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0", // Focus border color (green)
      },
    },
  };

  const searchData = async () => {
    setSearchLoading(true);
    try {
      const response = await searchUser({ codes: [searchTerm] });
      if (response?.data?.data || response?.data) {
        const userData = response.data.data || response.data;
        const isEmpty = Array.isArray(userData)
          ? userData.length === 0
          : Object.keys(userData).length === 0;

        if (isEmpty) {
          enqueueSnackbar("No data found", { variant: "error" });
          setData([]);
          setSearchValue("");
        } else {
          setData(userData);
        }
      } else if (response.status === 201) {
        enqueueSnackbar("no record found", { variant: "error" });
      } else {
        enqueueSnackbar("No use found.", { variant: "success" });
        setData([]);
      }
    } catch (error) {
      console.error("Search failed:", error);
      enqueueSnackbar("Failed to fetch user data.", { variant: "error" });
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSubmit = async () => {
    const resp = await AssingnDeactive(data[0].id);
    if (resp.status == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
    } else {
      enqueueSnackbar(
        resp?.error ||
          resp?.data?.error ||
          resp?.message ||
          resp?.data?.message,
        { variant: "error" }
      );
    }
  };

  const debounceSearch = useCallback(
    debounce((query) => {
      setSearchTerm(query);
    }, 1000),
    []
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    if (value.length <= 8) {
      debounceSearch(value);
    }
  };
  useEffect(() => {
    if (searchTerm.length === 8) {
      searchData();
    }
  }, [searchTerm]);
  return (
    <>
      <ArrowBackIcon
        sx={{ margin: 1, cursor: "pointer" }}
        onClick={() => navigate(-1)}
      />
      <div className="wallet-area">
        <div className="Wallet-form">
          <Typography variant="h5">
            <b>Reactive Users</b>
          </Typography>
          {data[0]?.name && (
            <>
              <Avatar
                alt={data[0]?.name}
                src={data[0]?.picture}
                sx={{ height: "100px", width: "100px", margin: "10px" }}
              />
              <Typography variant="h5">{data[0]?.name}</Typography>
            </>
          )}
          <Box sx={{ marginBottom: 2, marginTop: 2 }}>
            <TextField
              fullWidth
              label="Search RID *"
              variant="outlined"
              size="small"
              value={searchValue}
              onChange={handleSearch}
              sx={inputStyles}
              InputLabelProps={{ sx: labelStyles }}
              disabled={searchLoading}
            />
            <Button
              fullWidth
              variant="contained"
              onClick={handleSubmit}
              className="gradientButton"
              disabled={
                sendLoading || searchLoading || Object.keys(data).length === 0
              }
              sx={{ marginTop: 2, textTransform: "none" }}
            >
              {sendLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Update User Status "
              )}
            </Button>
          </Box>
        </div>
      </div>
    </>
  );
};

export default AddDeactiveUser;
